import { render, staticRenderFns } from "./ModalProdutoDestinacao.vue?vue&type=template&id=31c25d6c&scoped=true&"
import script from "./ModalProdutoDestinacao.vue?vue&type=script&lang=js&"
export * from "./ModalProdutoDestinacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalProdutoDestinacao.vue?vue&type=style&index=0&id=31c25d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c25d6c",
  null
  
)

export default component.exports